export const getMissingGuestLeadFields = (form, guestMode) => {
  if (guestMode !== "new") return [];

  const missingFields = [];
  if (!`${form?.guest_first_name || ""}`.trim()) missingFields.push("First Name");
  if (!`${form?.guest_last_name || ""}`.trim()) missingFields.push("Last Name");
  if (!`${form?.guest_phone || ""}`.trim()) missingFields.push("Mobile Phone");
  return missingFields;
};

// Legacy contact endpoints may wrap a database error as [null, error].
export const opportunitySaveError = (error) => {
  const messageFrom = (value, depth = 0) => {
    if (!value || depth > 4) return "";
    if (typeof value === "string") return value.includes("[object Object]") ? "" : value;
    if (Array.isArray(value)) return value.map((item) => messageFrom(item, depth + 1)).filter(Boolean).join("; ");
    return messageFrom(value.message || value.error, depth + 1);
  };
  const message = messageFrom(error?.response?.data?.error) || "Unable to save opportunity. Please try again; your form entries are preserved.";
  // UIkit notification strings are HTML; display server messages as text.
  return message.replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char]));
};
